import { applicationPaths, defaultPath, pagesWithDefaultVintage } from 'constants/apps'
import { useI18n } from 'context/I18nProvider'
import { useProfile } from 'context/ProfileProvider'
import * as React from 'react'
import { useRouteLoaderData } from 'react-router-dom'
import habilitationImage from './habilitation.png'
import trainingImage from './training.svg'

export function useDefaultURL(locale) {
  const { locale: defaultLocale } = useI18n()
  const settings = useRouteLoaderData('root')
  const user = useRouteLoaderData('user')
  const { profile } = useProfile()

  const { defaultVintage } = user

  let page = user.profile.defaultHomepage || settings.homepage || defaultPath
  if (page === 'dashboard' && profile?.type !== 'collaborator') {
    page = 'catalog'
  }
  const path = applicationPaths[page]

  const params = defaultVintage?.id && pagesWithDefaultVintage.includes(path) ? `?vintages[]=${defaultVintage.id}` : ''

  return `/${locale || defaultLocale}/${path}${params}`
}

export function useDefaultAnonymousURL(locale) {
  const { locale: defaultLocale } = useI18n()
  const settings = useRouteLoaderData('root')

  const path = applicationPaths[settings.homepage || defaultPath]

  return `/${locale || defaultLocale}/${path}`
}

/**
 * Training should always be the default app and cannot be deleted.
 * Its default landing page can be changed in the admin section, and if none is given it defaults to 'catalog',
 */
export function useApps() {
  const { i18n } = useI18n()
  const url = useDefaultURL()

  const training = React.useMemo(
    () => ({
      id: 0,
      editDisabled: true, // Used in admin/applications
      name: i18n('applications.training'),
      url,
      color: 'rgb(233,30,99)',
      icon: {
        extension: 'svg',
        url: trainingImage,
      },
    }),
    [i18n, url],
  )

  const habilitation = React.useMemo(
    () => ({
      id: 0,
      name: i18n('applications.habilitation'),
      color: 'rgb(233,30,99)',
      icon: {
        extension: 'png',
        url: habilitationImage,
      },
    }),
    [i18n],
  )

  return {
    habilitation,
    training,
  }
}
